import { authTypes } from '../auth/types'
import { FilesActions, filesTypes, FilesState } from './types'

const initialState: FilesState = {
  pdfUrl: ''
}

const reducer = (state = initialState, action: FilesActions): FilesState => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case filesTypes.SET_PDF: {
      return {
        ...state,
        pdfUrl: payload as string
      }
    }

    default:
      return state
  }
}

export default reducer
